<template>
<div ref="container" @click="emit('toggle', id)" style="cursor:pointer" class="background">
    <Icon icon="mdi:star-outline" width="24" height="24" color="var(--default-blue)" v-if="!selected"/>
    <Icon icon="mdi:star" width="24" height="24" color="var(--default-blue)" v-if="selected"/>
</div>
</template>

<script setup lang="js">
import { onMounted, onUpdated, ref } from 'vue';
import { Icon } from '@iconify/vue';

const props = defineProps({
    id: String,
    selected: Boolean,
})

const emit = defineEmits(['toggle'])

onMounted(() => {
})

onUpdated(() => console.log(props?.id))

const container = ref();
</script>

<style scoped>

.background {
    align-items: center;
    justify-items: center;
    width: 100px;
}

</style>